module.exports = __webpack_public_path__ + "static/media/login-page-user-icon.484e0691.svg";